import { hydrateRoot } from 'react-dom/client';
import { ReactRelayContext } from 'react-relay/legacy';
import { createOperationDescriptor, getRequest } from 'relay-runtime';

import serverVars from 'server-vars';
import { IntlProvider } from 'dibs-react-intl';
import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';

import { getRelayEnvironment } from '../utils/relayModernEnvironment';

import { SitemapWrapper } from '../sitemap/SitemapWrapper';
import { sitemapRoot } from '../sitemap/sitemapRoot';

const environment = getRelayEnvironment(serverVars.get('dbl.relayData'));

const variables = serverVars.get('relayVariables');
const operation = createOperationDescriptor(getRequest(sitemapRoot), variables);
const snapshot = environment.lookup(operation.fragment);

initializeDBL().then(() => {
    hydrateRoot(
        document.getElementById('js-root'),
        <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
            <ReactRelayContext.Provider
                value={{
                    environment,
                    variables: snapshot.variables || {},
                }}
            >
                <SitemapWrapper viewer={snapshot.data.viewer} {...variables} />
            </ReactRelayContext.Provider>
        </IntlProvider>
    );
});
